import Cookies from 'js-cookie'

const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
const generateUUID = function (len, radix) {
  let chars = CHARS
  let uuid = []
  let i
  radix = radix || chars.length
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    var r
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

const UUID_KEY = 'uuid'

export function getUUID () {
  if (!Cookies.get(UUID_KEY)) {
    const uuid = generateUUID()
    Cookies.set(UUID_KEY, uuid)
  }
  return Cookies.get(UUID_KEY)
}



// WEBPACK FOOTER //
// ./src/store/common/uuid.js